export const hsvToHsl = c => {
  const l = c.value - c.value * c.saturation / 2;
  const s = l === 0 || l === 1 ? 0 : (c.value - l) / Math.min(l, 1 - l);
  return {
    hue: c.hue,
    saturation: s,
    lightness: l
  };
};
//# sourceMappingURL=hsvToHsl.js.map